var globalWrapper = (typeof window !== "undefined" ? window : this);
if (!("fshr" in globalWrapper)) {
    globalWrapper.fshr = {};
}

// set default localization values
if (typeof globalWrapper.fshr.localization === "undefined") {
    globalWrapper.fshr.localization = {
        calendar: {
            closeText: 'Zavřít',
            prevText: '&#x3c;Dříve',
            nextText: 'Později&#x3e;',
            currentText: 'Nyní',
            monthNames: ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen',
                'září', 'říjen', 'listopad', 'prosinec'],
            monthNamesShort: ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen',
                'září', 'říjen', 'listopad', 'prosinec'],
            dayNames: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'],
            dayNamesShort: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
            dayNamesMin: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
            weekHeader: 'Týd',
            dateFormat: 'dd.mm.yy',
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: ''
        },
        nights: ["nocí", "noc", "noci"],
        hotels: ["hotel", "hotely", "hotelů"],
        free: "ZDARMA",
        time: {
            timeOnlyTitle: 'Vyberte čas',
            timeText: 'Čas',
            hourText: 'Hodin',
            minuteText: 'Minut',
            secondText: 'Sekund',
            currentText: 'Nyní',
            closeText: 'Zavřít'
        }
    };
}

globalWrapper.fshr.invalidateMaps = function (){
    if(window.hasOwnProperty("map")){
        var maps = window.map;
        for(var i in maps){
            var map = maps[i];
            map.$refs.map.mapObject.invalidateSize();
            map.fitBounds();
        }
    }
};

globalWrapper.fshr.isLocalhost = function () {
    return window.location.hostname == "localhost" && window.location.port != 55555;
};
globalWrapper.fshr.ajax = {
    inProgress: [],
    url: {
        quickSearch: "/quicksearch"
    },
    functions: {
        getPoolIndex: function (jqXHROrUrl, isUrl, isType) {
            var inProgress = globalWrapper.fshr.ajax.inProgress;
            var jqXHRindexes = [];
            jQuery.each(inProgress, function (index) {
                if (isType) {
                    if (this.type == jqXHROrUrl) {
                        jqXHRindexes.push(index);
                    }
                } else if (isUrl) {
                    if (this.url == jqXHROrUrl) {
                        jqXHRindexes.push(index);
                    }
                } else {
                    if (this.ajax == jqXHROrUrl) {
                        jqXHRindexes.push(index);
                    }
                }
            });
            return jqXHRindexes;
        },
        removeFromPool: function (jqXHR) {
            var indexes = globalWrapper.fshr.ajax.functions.getPoolIndex(jqXHR);
            for (var id = 0, indexesCount = indexes.length; id < indexesCount; id++) {
                var index = indexes[id];
                if (-1 < index) {
                    globalWrapper.fshr.ajax.inProgress.splice(index, 1);
                }
            }
        },
        abortAndRemove: function (jqXHROrUrl, isUrl, isType) {
            var indexes = globalWrapper.fshr.ajax.functions.getPoolIndex(jqXHROrUrl, isUrl, isType);
            for (var id = 0, indexesCount = indexes.length; id < indexesCount; id++) {
                var index = indexes[id];
                var inProgress = globalWrapper.fshr.ajax.inProgress[index];
                if (inProgress) {
                    globalWrapper.fshr.ajax.functions.removeFromPool(inProgress.ajax);
                    inProgress.ajax.abort();
                }
            }
        },
        abortAll: function (url, type) {
            if (type) {
                globalWrapper.fshr.ajax.functions.abortAndRemove(type, false, true);
            } else if (url) {
                globalWrapper.fshr.ajax.functions.abortAndRemove(url, true, false);
            } else {
                jQuery.each(globalWrapper.fshr.ajax.inProgress, function (index, jqXHR) {
                    globalWrapper.fshr.ajax.functions.abortAndRemove(jqXHR);
                });
            }
        },
        send: function (url, data, customOptions, ajaxType) {


                var options = {
                    url: url,
                    data: data,
                    method: "get",
                    dataType: "html",
                    complete: function (jqXHR) {
                        globalWrapper.fshr.ajax.functions.removeFromPool(jqXHR);
                        //resolve(jqXHR);
                    },
                    error: function (result) {
                        console.warn(result);
                        //reject(result);
                    }
                };
                $.extend(options, customOptions);

                globalWrapper.fshr.ajax.inProgress.push({
                    url: url,
                    type: ajaxType,
                    ajax: $.ajax(options)
                });

            //return promise;
        }
    }
};
globalWrapper.fshr.mapSourceUrl = "https://maps.fischer.cz/styles/streets/style.json";
globalWrapper.fshr.setMapZoom = function (map) {
    var currentMapZoom = map.getZoom();
    var minimumMapZoom = 15;
    var newZoom = Math.min(currentMapZoom, minimumMapZoom);
    map.setZoom(newZoom);
};
globalWrapper.fshr.getInfoboxOffset = function (imagesCount) {
    var xOffset = -200;
    if (typeof imagesCount !== "undefined" && !imagesCount) {
        xOffset = xOffset + 87;
    }
    var yOffset = -45;
    var viewportWidth = window.innerWidth;
    if (viewportWidth < 600) {
        xOffset = -65;
        yOffset = -40;
    } else if (viewportWidth < 800) {
        xOffset = -115;
        yOffset = -45;
    }
    return {
        xOffset: xOffset,
        yOffset: yOffset
    };
};
globalWrapper.fshr.windowSizeToQtipFullscreen = 800;
globalWrapper.fshr.IMAGES_PATH = globalWrapper.fshr.isLocalhost() ? "/Content/images/" : "/Content/images/";
globalWrapper.fshr.MAP_IMAGES_FOLDER = "map/";
globalWrapper.fshr.dates = {
    minimum: new Date(),
    maximum: new Date(new Date().getFullYear() + 1, 11, 31)
};

globalWrapper.fshr.getInfoboxOffsetLEAFLET = function (imagesCount) {
    var xOffset = -200;
    if (typeof imagesCount !== "undefined" && !imagesCount) {
        xOffset = xOffset + 87;
    }
    //var yOffset = -45;
    var yOffset = -10;
    /*
    var viewportWidth = window.innerWidth;
    if (viewportWidth < 600) {
        xOffset = -65;
        yOffset = -40;
    } else if (viewportWidth < 800) {
        xOffset = -115;
        yOffset = -45;
    }
     */
    return {
        xOffset: 0,
        yOffset: yOffset
    };
};

globalWrapper.fshr.handleLazyLoad = function ($lazyLoadItem) {
    var global = globalWrapper.fshr;
    $lazyLoadItem.removeClass("js-lazyLoad").removeClass("js-lazyCarouselLoad");
    var src = $lazyLoadItem.attr("data-lazy-src");
    var style = $lazyLoadItem.attr("data-lazy-style");
    if (src) {
        $lazyLoadItem.attr("src", src);
    } else if (style) {
        $lazyLoadItem.attr("style", style);
    } else if ($lazyLoadItem.is(".js-google-map")) {
        global.initializeMap($lazyLoadItem);
    } else if ($lazyLoadItem.is(".js-google-map-branches")) {
        global.initializeMapBranches($lazyLoadItem);
    } else if ($lazyLoadItem.is(".js-google-map-streetView")) {
        global.initializeMapStreetView($lazyLoadItem);
    } else if ($lazyLoadItem.is(".js-skimap")) {
        if (!$lazyLoadItem.closest(".js-gallery, .js-gallery-generated").length) {
            global.initializeMapSki($lazyLoadItem);
        }
    }
};
globalWrapper.fshr.clickEventName = ('ontouchstart' in document.documentElement) ? 'tap' : 'click';
globalWrapper.fshr.isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
if (globalWrapper.fshr.isTouchDevice) {
    $("body").addClass("touch-device");
}
globalWrapper.fshr.updateUrlParameters = function (parameters) {
    var location = window.location;
    var hash = location.hash;
    if ("history" in window && "pushState" in window.history) {
        var url = location.protocol + "//" + location.host + location.pathname + "?" + parameters + hash;
        window.history.pushState({reloadPage: true}, null, url);
    } else {
        window.location.search = parameters;
        window.location.hash = hash;
    }
};


globalWrapper.fshr.getElementsBySelector = function (selectors, $elementForTraversingStart) {
    var $elementsToReturn = [];
    if (typeof selectors === "string") {
        var selectorsArray = selectors.split(",");
        for (var index1 = 0; index1 < selectorsArray.length; index1++) {
            var selector = selectorsArray[index1];
            var extendedArray = selector.match(/find\(|parents\(|closest\(|prev\(|next\(|parent\(/g);
            var $elements = $();
            if (extendedArray && typeof $elementForTraversingStart !== "undefined") {
                var selectorFragments = selector.split("->");
                var fragmentsCount = selectorFragments.length;
                $elements = $elementForTraversingStart;
                for (var index = 0; index < fragmentsCount; index++) {
                    var fragment = selectorFragments[index];
                    var fragmentType = fragment.replace(/\(.*/gi, "");
                    var regular = new RegExp(fragmentType + "\\(|\\)$", "gi");
                    var itemSelector = fragment.replace(regular, "");
                    switch (fragmentType) {
                        case "find":
                            $elements = $elements.find(itemSelector);
                        break;
                        case "parents":
                            $elements = $elements.parents(itemSelector);
                        break;
                        case "parent":
                            $elements = $elements.parent(itemSelector);
                        break;
                        case "closest":
                            $elements = $elements.closest(itemSelector);
                        break;
                        case "prev":
                            $elements = $elements.prev(itemSelector);
                        break;
                        case "next":
                            $elements = $elements.next(itemSelector);
                        break;
                    }
                }
            } else {
                try {
                    $elements = $(selector);
                } catch (error) {
                }
            }
            var elements = $elements.get();
            if (elements.length) {
                $.each(elements, function () {
                    if (this) {
                        $elementsToReturn.push(this);
                    }
                });
            }
        };
    }
    return $elementsToReturn.length ? $($elementsToReturn) : $(null);
};
globalWrapper.fshr.formatNumberAsPrice = function (number, precision) {
    var returnValue = 0;
    if (precision) {
        returnValue = number.toFixed(precision).replace(/(\d)(?=(\d{3})+\.)/g, '$1&nbsp;');
    } else {
        returnValue = number.toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1&nbsp;');
    }
    return returnValue;
};
globalWrapper.fshr.removeDiacritics = function (str) {
    var defaultDiacriticsRemovalap = [
            {'base':'A', 'letters':'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
            {'base':'AA','letters':'\uA732'},
            {'base':'AE','letters':'\u00C6\u01FC\u01E2'},
            {'base':'AO','letters':'\uA734'},
            {'base':'AU','letters':'\uA736'},
            {'base':'AV','letters':'\uA738\uA73A'},
            {'base':'AY','letters':'\uA73C'},
            {'base':'B', 'letters':'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
            {'base':'C', 'letters':'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
            {'base':'D', 'letters':'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},
            {'base':'DZ','letters':'\u01F1\u01C4'},
            {'base':'Dz','letters':'\u01F2\u01C5'},
            {'base':'E', 'letters':'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
            {'base':'F', 'letters':'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
            {'base':'G', 'letters':'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
            {'base':'H', 'letters':'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
            {'base':'I', 'letters':'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
            {'base':'J', 'letters':'\u004A\u24BF\uFF2A\u0134\u0248'},
            {'base':'K', 'letters':'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
            {'base':'L', 'letters':'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
            {'base':'LJ','letters':'\u01C7'},
            {'base':'Lj','letters':'\u01C8'},
            {'base':'M', 'letters':'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
            {'base':'N', 'letters':'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
            {'base':'NJ','letters':'\u01CA'},
            {'base':'Nj','letters':'\u01CB'},
            {'base':'O', 'letters':'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
            {'base':'OI','letters':'\u01A2'},
            {'base':'OO','letters':'\uA74E'},
            {'base':'OU','letters':'\u0222'},
            {'base':'OE','letters':'\u008C\u0152'},
            {'base':'oe','letters':'\u009C\u0153'},
            {'base':'P', 'letters':'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
            {'base':'Q', 'letters':'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
            {'base':'R', 'letters':'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
            {'base':'S', 'letters':'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
            {'base':'T', 'letters':'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
            {'base':'TZ','letters':'\uA728'},
            {'base':'U', 'letters':'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
            {'base':'V', 'letters':'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
            {'base':'VY','letters':'\uA760'},
            {'base':'W', 'letters':'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
            {'base':'X', 'letters':'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
            {'base':'Y', 'letters':'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
            {'base':'Z', 'letters':'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
            {'base':'a', 'letters':'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'},
            {'base':'aa','letters':'\uA733'},
            {'base':'ae','letters':'\u00E6\u01FD\u01E3'},
            {'base':'ao','letters':'\uA735'},
            {'base':'au','letters':'\uA737'},
            {'base':'av','letters':'\uA739\uA73B'},
            {'base':'ay','letters':'\uA73D'},
            {'base':'b', 'letters':'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
            {'base':'c', 'letters':'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
            {'base':'d', 'letters':'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
            {'base':'dz','letters':'\u01F3\u01C6'},
            {'base':'e', 'letters':'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
            {'base':'f', 'letters':'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
            {'base':'g', 'letters':'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
            {'base':'h', 'letters':'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
            {'base':'hv','letters':'\u0195'},
            {'base':'i', 'letters':'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
            {'base':'j', 'letters':'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
            {'base':'k', 'letters':'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
            {'base':'l', 'letters':'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
            {'base':'lj','letters':'\u01C9'},
            {'base':'m', 'letters':'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
            {'base':'n', 'letters':'\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'},
            {'base':'nj','letters':'\u01CC'},
            {'base':'o', 'letters':'\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
            {'base':'oi','letters':'\u01A3'},
            {'base':'ou','letters':'\u0223'},
            {'base':'oo','letters':'\uA74F'},
            {'base':'p','letters':'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
            {'base':'q','letters':'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
            {'base':'r','letters':'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
            {'base':'s','letters':'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
            {'base':'t','letters':'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
            {'base':'tz','letters':'\uA729'},
            {'base':'u','letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
            {'base':'v','letters':'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
            {'base':'vy','letters':'\uA761'},
            {'base':'w','letters':'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
            {'base':'x','letters':'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
            {'base':'y','letters':'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
            {'base':'z','letters':'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
        ];

        var diacriticsMap = {};
        for (var i=0; i < defaultDiacriticsRemovalap.length; i++){
            var letters = defaultDiacriticsRemovalap[i].letters;
            for (var j=0; j < letters.length ; j++){
                diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
            }
        }

        return str.replace(/[^\u0000-\u007E]/g, function(a){
           return diacriticsMap[a] || a;
        });
};
globalWrapper.fshr.actualScrollTop = $(window).scrollTop();
globalWrapper.fshr.initializeQtip = function ($this) {

    if (typeof $this === "undefined" || typeof $this === "number") {
        $this = $(this);
    }


    function firstInitializeQtip ($this) {
        var contentSelector = $this.attr("data-tooltip-selector");
        var $content = globalWrapper.fshr.getElementsBySelector(contentSelector, $this);
        if ($content.hasClass("js-tooltip--price")) {
            $content = $content.clone();
        }
        var ajaxUrl = $this.attr("data-tooltip-ajaxurl");
        var style = "fshr-tooltip-block";
        var $contentNew = $content;
        var showEvent = false;
        var hideEvent = false;
        var events = {
            show: function () {},
            hide: function () {}
        };
        if (ajaxUrl) {
            $this.addClass("js-tooltip--customHtmlContent");
            events = {
                show: function (event, api) {
                    var $tooltip = this;
                    if (!$tooltip.is(".js-tooltip--loaded")) {
                        $tooltip.find(".qtip-content").html('<div class="js-tooltip-content"><div class="fshr-tooltip-box fshr-ajax--loading"></div></div>');

                        var options = {
                            success: function (data) {
                                $tooltip.find(".qtip-content").html('<div class="js-tooltip-content js-tooltip--loaded"><div class="fshr-tooltip-box">' + data + '</div></div>');
                                $tooltip.addClass("js-tooltip--loaded");
                                api.reposition(null, false);
                            }
                        };
                        globalWrapper.fshr.ajax.functions.send(ajaxUrl, "", options);
                    }
                    $("body").addClass("fshr-tooltipOpened");
                },
                hide: function () {
                    $("body").removeClass("fshr-tooltipOpened");
                }
            };
        } else if (!$content || !$content.length) {
            var title = $this.attr("title");
            if (title) {
                $contentNew = $("<div class='fshr-tooltip-box'>" + title + "</div>");
                style = "fshr-tooltip-inline";
            }
            showEvent = "mouseenter";
            hideEvent = "mouseleave";
        } else {
            $this.addClass("js-tooltip--customHtmlContent");
            events = {
                show: function (event, api) {
                    var $content = api.get("content.text");
                    if ($content.hasClass("js-tooltip--price") && !$content.hasClass("js-allPricesUpdated")) {
                        var $triggerElement = $(api.elements.target);
                        var contentSelector = $triggerElement.attr("data-tooltip-selector");
                        var $content = globalWrapper.fshr.getElementsBySelector(contentSelector, $triggerElement);
                        api.set("content.text", $content.clone());
                    }
                    $("body").addClass("fshr-tooltipOpened");
                },
                hide: function () {
                    $("body").removeClass("fshr-tooltipOpened");
                }
            };
        }


        if($this.hasClass("js-hideOnMobile") && $(window).outerWidth()<800){

        }else{
            $this.qtip({
                content: {
                    title: {
                        button: "x"
                    },
                    text: $contentNew
                },
                style: style,
                position: {
                    my: "bottom center",
                    at: "top center",
                    adjust: {
                        y: 0,
                        method: "shift flip"
                    },
                    viewport: $(window)
                },
                show: {
                    event: showEvent,
                    solo: true
                },
                hide: {
                    event: hideEvent,
                    delay: 0
                },
                events: events
            });
        }
    }
    function handleCustomTriggerEvents (event) {
        var $qtip = $(this);
        var api = $qtip.qtip("api");
        var showEvent = "mouseenter";
        var hideEvent = "mouseleave";
        var viewportWidth = window.innerWidth || $(window).outerWidth(true);

        if (viewportWidth < globalWrapper.fshr.windowSizeToQtipFullscreen) {
            showEvent = globalWrapper.fshr.clickEventName;
            hideEvent = globalWrapper.fshr.clickEventName;
        }
        if (typeof api !== "undefined") {
            if (event.type === hideEvent) {
                api.toggle(false);
            }

            if (event.type === showEvent) {
                api.toggle(true);
            }
        }
    }

    firstInitializeQtip($this);
    if ($this.is(".js-tooltip--customHtmlContent")) {
        $this.on("mouseenter mouseleave " + globalWrapper.fshr.clickEventName, handleCustomTriggerEvents);
    }
};
globalWrapper.fshr.generateStars = function () {
    var $this = $(this);

    var starsText = $this.text().toLowerCase();
    var isSuperior = starsText.indexOf("s") > -1;
    starsText = starsText.replace("s", "");
    var stars = starsText.split("/");
    var parts = [];
    var isSpades = $this.is(".js-stars--spades");

    if (isSpades) {
        $this.addClass("fshr-spades")
    }

    $.each(stars, function () {
        var text = this;
        if (isSpades) {
            text = text.replace(/\*/g, "♣");
        }
        parts.push("<span class='fshr-stars--styled'>" + text + "</span>");
    });


    $this.html(parts.join("<span class='fshr-stars--separator'>/</span>") + (isSuperior ? "<span class='fshr-text fshr-text--superior'>S</span>" : ""));
};
globalWrapper.fshr.isJSON = function (string) {
    var returnValue = true;
    try {
        JSON.parse(string);
    } catch (error) {
        returnValue = false;
    }
    return returnValue;
};
globalWrapper.fshr.getPriceFromString = function (string) {
    return parseFloat(string.replace(/ /g, "").replace(",", "."));
};
globalWrapper.fshr.getDaysCountAndMiliseconds = function (currentDate, rangeElementDate) {
    var millisecondsInMinute = 1000 * 60;
    var millisecondsInDay = millisecondsInMinute * 60 * 24;


    var startDateInMilliseconds = currentDate.getTime();
    var startDateTimezone = currentDate.getTimezoneOffset();
    var endDateInMilliseconds = rangeElementDate.getTime();
    var endDateTimezone = rangeElementDate.getTimezoneOffset();
    var dateDifferenceMilliseconds = endDateInMilliseconds - startDateInMilliseconds;
    var timeZonesDifferenceInMilliseconds = (endDateTimezone - startDateTimezone) * millisecondsInMinute;

    var daysCount = dateDifferenceMilliseconds / millisecondsInDay;
    daysCount = Math.round(daysCount);
    return {
        currentDate: currentDate,
        rangeElementDate: rangeElementDate,
        daysCount: daysCount,
        startDateInMilliseconds: startDateInMilliseconds,
        millisecondsInDay: millisecondsInDay,
        timeZonesDifferenceInMilliseconds: timeZonesDifferenceInMilliseconds
    };
};

globalWrapper.fshr.getDetailFilterJson = function (defaultJson, dataToSend, initializeLoad) {
    var global = globalWrapper.fshr;
    var newJson = $.extend({}, defaultJson);

    var parameterKey = global.filterDetailKeys;
    var parameters = dataToSend.params;
    var roomsCount = dataToSend.roomsCount;

    var datesKey = parameterKey.dates.toUpperCase();
    var mealKey = parameterKey.meal.toUpperCase();
    var airlineKey = parameterKey.airlines.toUpperCase();
    var travelOriginKey = parameterKey.travelOrigin.toUpperCase();
    var travelTypeKey = parameterKey.travelType.toUpperCase();
    var dateRangeValuesKey = parameterKey.dateRangeValues.toUpperCase();
    var dateExactRangeValuesKey = parameterKey.dateExactRange.toUpperCase();
    var roomTypeKey = parameterKey.roomType.toUpperCase();
    var roomCompleteKey = parameterKey.roomComplete.toUpperCase();

    if (!initializeLoad) {
        newJson.datesFrom = [];
        newJson.mealType = [];
        newJson.exactRange = 0;
        newJson.travelOrigins = [];
        newJson.travelTypes = [];
        newJson.numberOfNights = [];
        newJson.roomType = [];
        newJson.roomComplete = [];
    }

    if (datesKey in parameters) {
        newJson.datesFrom = parameters[datesKey].split("|");
    }

    if (airlineKey in parameters) {
        newJson.airlines = parameters[airlineKey].split("|");
    } else {
        newJson.airlines = [];
    }
    if (mealKey in parameters) {
        newJson.mealType = parameters[mealKey].split("|");
    }

    if (dateRangeValuesKey in parameters) {
        newJson.numberOfNights = parameters[dateRangeValuesKey].split("|");
    }

    if (dateExactRangeValuesKey in parameters) {
        newJson.exactRange = parameters[dateExactRangeValuesKey];
        if (parameters[dateExactRangeValuesKey] && datesKey in parameters && newJson.datesFrom.length) {
            if (newJson.datesFrom.length > 1) {
                var firstDate = new Date(newJson.datesFrom[0]);
                var lastDate = new Date(newJson.datesFrom[newJson.datesFrom.length - 1]);
                var timeDiff = Math.abs(firstDate.getTime() - lastDate.getTime());
                newJson.numberOfNights = [Math.ceil(timeDiff / (1000 * 3600 * 24))];
            } else {
                newJson.numberOfNights = [1];
            }
        }
    } else {
        newJson.exactRange = 0;
    }

    if (travelOriginKey in parameters) {
        var originStrings = parameters[travelOriginKey].split("|");
        newJson.travelOrigins = [];
        $.each(originStrings, function () {
            newJson.travelOrigins.push(parseInt(this, 10));
        });
    }
    if (travelTypeKey in parameters) {
        var travelTypeStrings = parameters[travelTypeKey].split("|");
        newJson.travelTypes = [];
        $.each(travelTypeStrings, function () {
            newJson.travelTypes.push(parseInt(this, 10));
        });
    }

    if (roomTypeKey in parameters) {
        newJson.roomType = parameters[roomTypeKey].split("|");
    }
    if (roomCompleteKey in parameters) {
        newJson.roomComplete = parameters[roomCompleteKey].split("|");
    }

    if (roomsCount > 0) {
        newJson.rooms = [];
    }
    for (var room = 1; room <= roomsCount; room++) {
        var adults = parameters[parameterKey.adultsCount.toUpperCase() + room] || 0;
        var children = parameters[parameterKey.childrenCount.toUpperCase() + room] || 0;
        var ages = [];
        if ((parameterKey.childrenAge.toUpperCase() + room) in parameters) {
            ages = parameters[parameterKey.childrenAge.toUpperCase() + room].split("|");
        }
        if ((parameterKey.infantsCount.toUpperCase() + room) in parameters) {
            var infantsCount = parameters[parameterKey.infantsCount.toUpperCase() + room];
            for (var infant = 0; infant < infantsCount; infant++) {
                ages.push(0);
            }
        }
        if ("rooms" in newJson) {
            newJson.rooms.push({
                adults: adults,
                ages: ages,
                children: children
            });
        }
    }

    $.extend(defaultJson, newJson);

    if (newJson.exactRange) {
        newJson.datesFrom = [newJson.datesFrom[0]];
    }

    return defaultJson;
};

/*
globalWrapper.fshr.daysCountRestrictions = function ($object) {
    var $objectParent = $object.closest(".js-filter");
    var isDetail = $objectParent.is(".js-filter--detail");
    var $objectStart = $("#filter-departure-date");
    var $objectEnd = $("#filter-return-date");
    if (isDetail) {
        $objectStart = $("#filter-departure-date-detail");
        $objectEnd = $("#filter-return-date-detail");
    }
    var $userDaysSelect = $objectParent.find("select.js-selectCustom");
    var $selectParent = $userDaysSelect.parent();
    var nightsCount = globalWrapper.fshr.getDaysCountAndMiliseconds(new Date($objectStart.val()), new Date($objectEnd.val())).daysCount;
    var $daysOptions = $userDaysSelect.find("option");

    $daysOptions.prop("disabled", false);
    $selectParent.find("input[type=checkbox]").prop("disabled", false);

    var $userDaysCountSelected = $daysOptions.filter(":selected");
    var checkedCount = $selectParent.find(".js-select-item:not(.fshr-option--grouped) input:checked, .js-select-item.fshr-option--grouped.js-exactRange input:checked").length;
    var uncheckedCount = 0;

    $daysOptions.each(function () {
        var $option = $(this);
        var value = $option.attr("data-value");
        if (value) {
            var values = value.split(",");
            var lastValue = values[0];
            if (lastValue > nightsCount) {
                $option.prop("disabled", true).prop("selected", false);
                $selectParent.find(".js-select-item[data-value='" + value + "'] input").prop("disabled", true).prop("checked", false);
            }
        }
    });

    $userDaysCountSelected.each(function () {
        var $option = $(this);
        var values = $option.attr("data-value") || $option.attr("value") || $option.text();
        if (values) {
            values = values.split(",");
            var firstValue = values[0];

            if (firstValue > nightsCount) {
                for (var valueIndex = 0, valuesCount = values.length; valueIndex < valuesCount; valueIndex++) {
                    var value = values[valueIndex];
                    if (value > nightsCount) {
                        var $item = $selectParent.find(".js-select-item:not(.fshr-option--grouped)[data-value=" + value + "] input:checked");
                        if ($item.length) {
                            $item.prop("checked", false).trigger("change");
                            uncheckedCount++;
                        }
                    }
                }
            }
        }
    });

    var $selectWrapper = $objectParent.find(".js-select-wrapper");
    if (!$("body").is(".js-filterSetFromUrl")) {
        var changedByUser = $selectWrapper.is(".js-select--modifiedByUser");

        if (!changedByUser) {
            $selectParent.find(".js-select-item input").prop("checked", false);
            if (nightsCount <= 7) {
                $selectParent.find(".js-exactRange input").prop("checked", true).trigger("change");
            } else if (nightsCount == 8) {
                $selectParent.find(".js-select-item[data-value='7'] input, .js-select-item[data-value='8'] input").prop("checked", true).trigger("change");
            } else {
                $selectParent.find(".js-select-item[data-value='7,8,9'] input").prop("checked", true).trigger("change");
            }
        } else if (uncheckedCount == checkedCount) {
            if (nightsCount < 9) {
                $selectParent.find(".js-exactRange input").prop("checked", true).trigger("change");
            } else {
                $selectParent.find(".js-select-item[data-value='7,8,9'] input").prop("checked", true).trigger("change");
            }
        }
    }

    $selectParent.find(".js-select-item.fshr-option--grouped:not(.js-exactRange) input:checked").trigger("change");
};
*/

globalWrapper.fshr.checkSameCheckbox = function ($checkboxes) {
    var $sameCheckboxesToReturn = $();
    $checkboxes.each(function () {
        var $checkbox = $(this);
        var itemId = $checkbox.attr("data-item-id");
        if (itemId) {
            var $parent = $checkbox.closest(".js-sameCheckboxes");
            var $sameCheckboxes = $parent.find("input[type=checkbox][data-item-id=" + itemId + "]:not(:disabled)").not($checkbox);
            var checkboxState = $checkbox.prop("checked");
            $sameCheckboxes.prop("checked", checkboxState);
            $sameCheckboxesToReturn = $sameCheckboxesToReturn.add($sameCheckboxes);
        }
    });
    return $sameCheckboxesToReturn;
};

globalWrapper.fshr.getStars = function (stars, areSpades) {
    return $("<span class='fshr-stars" + (areSpades ? " js-stars--spades" : "") + "'>" + stars + "</span>");
};

globalWrapper.fshr.mapsFcs = {
    closeAllInfoBoxes: function (allInfoBoxes) {
        for (var markerId in allInfoBoxes) {
            if (allInfoBoxes.hasOwnProperty(markerId)) {
                var infoBox = allInfoBoxes[markerId];
                infoBox.close();
            }
        }
    },
    openInfoBox: function (currentInfoBox, marker, map, allInfoBoxes) {
        if (typeof allInfoBoxes !== "undefined") {
            globalWrapper.fshr.mapsFcs.closeAllInfoBoxes(allInfoBoxes);
        }
        var $infoBox = $(currentInfoBox.getContent());
        var $lazyLoad = $infoBox.find(".js-lazyLoad");
        if ($lazyLoad.length) {
            $lazyLoad.each(function () {
                globalWrapper.fshr.handleLazyLoad($(this));
            });
        }
        currentInfoBox.open(map, marker);
    },
    openInfoBoxLEAFLET: function openInfoBoxLEAFLET (currentInfoBox, marker, map) {
        //closeAllInfoBoxesLEAFLET(map);
        var $infoBox = $(currentInfoBox.getContent());
        /*
        var $lazyLoad = $infoBox.find(".js-lazyLoad");
        if ($lazyLoad.length) {
            $lazyLoad.each(function () {
                globalWrapper.fshr.handleLazyLoad($(this));
            });
        }
         */
        setTimeout(function () {
            if (!marker._icon) {
                marker.__parent.spiderfy();
            }
            marker.openPopup();
        }, 500);
    },
    getInfoBoxContent: function (marker) {
        var title = marker.text;
        var url = marker.url;
        var markerContent = marker.content;
        var gtm = marker.gtm;
        var global = globalWrapper.fshr;

        if (markerContent) {
            title = markerContent.title;
            var starsHtml = "";
            if (markerContent.stars) {
                var $starsHtml = $("<span class='fshr-stars' data-stars='" + markerContent.stars + "'></span>").each(global.generateStars);

                starsHtml = $("<div></div>").append($starsHtml).html();
            }
            var tripadvisorHtml = markerContent.tripadvisorSrc ? "<p class='fshr-mapItemTooltip-tripadvisor'><img src='" + markerContent.tripadvisorSrc + "' alt=''>" + (markerContent.tripadvisorText ? "<span class='fshr-mapItemTooltip-tripadvisorText'>" + markerContent.tripadvisorText + "</span>" : "") + "</p>" : "";
            var imageHtml = markerContent.imageSrc ? "<div class='fshr-mapItemTooltip-image js-lazyLoad' data-lazy-style='background-image: url(" + markerContent.imageSrc + ");'></div>" : "";
            var priceHtml = markerContent.priceText ? "<p class='fshr-paragraph fshr-paragraph--last'><strong>" + markerContent.priceText + "</strong></p>" : "";

            var locationsHtml = "";
            if (markerContent.locations && markerContent.locations.length) {
                locationsHtml = "<ol class='fshr-breadcrumb'>";
                for (var locationIndex = 0, locationsCount = markerContent.locations.length; locationIndex < locationsCount; locationIndex++) {
                    var location = markerContent.locations[locationIndex];
                    var locationTitle = (location.title ? location.title : "");
                    locationsHtml = locationsHtml + " <li class='fshr-breadcrumb-item'>" + locationTitle + "</li>";
                }
                locationsHtml = locationsHtml + "</ol>";
            }

            var pictogramsHtml = "";
            if (markerContent.pictograms && markerContent.pictograms.length) {
                pictogramsHtml = "<p class='fshr-searchResults-icons'>";
                for (var pictogramIndex = 0, pictogramsCount = markerContent.pictograms.length; pictogramIndex < pictogramsCount; pictogramIndex++) {
                    var pictogram = markerContent.pictograms[pictogramIndex];
                    pictogramsHtml = pictogramsHtml + "<span class='js-tooltip fshr-icon fshr-icon--circled " + (pictogram.icon ? pictogram.icon : "") + "' title='" + (pictogram.title ? pictogram.title : "") + "'></span> ";
                }
                pictogramsHtml = pictogramsHtml + "</p>";
            }
        }

        var $html = $(url ? "<a target='_blank' href='" + url + "' class='fshr-mapItemTooltip" + ( !markerContent.imageSrc ? " fshr-mapItemTooltip--noImage" : "") + "'></a>" : "<div class='fshr-mapItemTooltip" + ( !markerContent.imageSrc ? " fshr-mapItemTooltip--noImage" : "") + "'></div>");
        if (gtm) {
            if ("productClick" in gtm) {
                $html.addClass("js-gtm-productClick");
                $html.attr("data-gtm-impression", JSON.stringify(gtm.productClick));
                $html.attr("data-gtm-currencycode", "CZK");
                if ("currencyCode" in gtm) {
                    $html.attr("data-gtm-currencycode", gtm.currencyCode);
                }
            }
            if ("eventClick" in gtm) {
                $html.addClass("js-gtm-eventClick");
                $html.attr("data-gtm-eventclick-action", "MapToDetail");
                $html.attr("data-gtm-eventclick-category", "Click");
                $html.attr("data-gtm-eventclick-label", gtm.eventClick.name);
            }
        }
        var $content = $("" +
            "<div class='fshr-mapItemTooltip-content'>" +
            imageHtml +
            starsHtml +
            "   <p class='fshr-mapItemTooltip-title'>" + title + "</p>" +
            tripadvisorHtml +
            locationsHtml +
            pictogramsHtml +
            priceHtml +
            "</div>");
        $content.find(".js-tooltip").each(global.initializeQtip);
        $html.append($content);
        return $html[0];
    },
    getInfoboxOffset: globalWrapper.fshr.getInfoboxOffset,
    getLeftPanelHotel: function (hotel) {
        var title = hotel.text;
        var id = hotel.id;
        var markerContent = hotel.content;
        var gtm = hotel.gtm;
        var global = globalWrapper.fshr;

        if (markerContent) {
            title = markerContent.title;
            var starsHtml = "";
            if (markerContent.stars) {
                var $starsHtml = $("<span class='fshr-stars' data-stars='" + markerContent.stars + "'></span>").each(global.generateStars);

                starsHtml = $("<div></div>").append($starsHtml).html();
            }
            var tripadvisorHtml = markerContent.tripadvisorSrc ? "<p class='fshr-tripadvisor-thumbnail-image'><img src='" + markerContent.tripadvisorSrc + "' alt=''></p>" : "";
            var imageHtml = markerContent.imageSmallSrc ? "<div class='fshr-searchResults-image'><img src='" + markerContent.imageSmallSrc + "' alt=''></div>" : "";
            var priceHtml = markerContent.priceText ? "<strong class='fshr-searchResult-item-price'>" + markerContent.priceText + "</strong>" : "";

            var locationsHtml = "";
            if (markerContent.locations && markerContent.locations.length) {
                locationsHtml = "<ol class='fshr-breadcrumb'>";
                for (var locationIndex = 0, locationsCount = markerContent.locations.length; locationIndex < locationsCount; locationIndex++) {
                    var location = markerContent.locations[locationIndex];
                    var locationTitle = (location.title ? location.title : "");
                    locationsHtml = locationsHtml + " <li class='fshr-breadcrumb-item'>" + locationTitle + "</li>";
                }
                locationsHtml = locationsHtml + "</ol>";
            }
        }

        var $html = $("<a href='' data-mappinid='" + id + "' class='fshr-searchResults-item--shrinked fshr-anchor--asText js-mapActivePin js-showOnMap'></a>");
        var $content = $("" +
            "<div class='grd-container'>" +
                "<div class='grd-row'>" +
                    "<div class='grd-col grd-col--4'>" +
                        imageHtml +
                    "</div>" +
                    "<div class='grd-col grd-col--8'>" +
                        "<p class='fshr-title fshr-title--productThumbnail'>" + title + starsHtml + "</p>" +
                        locationsHtml +
                        "<div class='fshr-searchResult-item-footer'>" +
                            tripadvisorHtml +
                            priceHtml +
                        "</div>" +
                    "</div>" +
                "</div>" +
            "</div>");
        $html.append($content);
        return $html[0];
    },
    getLeftPanelGroup: function (group) {
        var title = group.title;
        var id = group.id;
        var price = group.priceText;
        var count = group.count;
        var global = globalWrapper.fshr;

        var $content = $("" +
        "<div class='fshr-searchResults-group-header' data-groupid='" + id + "'>" +
            "<div class='grd-container'>" +
                "<div class='grd-row'>" +
                    "<div class='fshr-searchResultsGroup-itemInfo grd-col--md-4 grd-col--smd-12'>" +
                        "<div class='grd-col grd-col--10-3 grd-col--md-12 grd-col--smd-6 fshr-searchResults-group-title'>" +
                            "<span class='fshr-searchResults-group-controls'>+</span>" +
                            "<div class='fshr-title--asText'>" + title + "</div>" +
                        "</div>" +
                        "<div class='grd-col grd-col--10-2 grd-col--md-12 grd-col--smd-6 fshr-searchResults-group-hotels'><b>" + count + " " + global.getProperSuffix(count, global.localization.hotels.join(",")) + "</b></div>" +
                    "</div>" +
                    "<div class='grd-col grd-col--10-2 grd-col--md-4 grd-col--smd-6 fshr-searchResults-group-price'>" +
                        "<b class='fshr-price'>" + price + "</b>" +
                    "</div>" +
                "</div>" +
            "</div>" +
        "</div>" +
        "<div class='fshr-searchResults-items'></div>"
        );

        var $html = $("<div class='fshr-searchResults-group'></div>");

        $html.append($content);
        return $html[0];
    },
    showHotelsOnMap: function (map, places, fitBounds, handleCurrentHotel) {
        var $map = $(map.getDiv());
        var mapId = $map.attr("id");
        var global = globalWrapper.fshr;
        global.commonMaps = global.commonMaps || {};
        if (typeof fitBounds === "undefined") {
            fitBounds = false;
        }
        var bounds = new google.maps.LatLngBounds();
        var clustererPositions = [];
        var infoboxOffset = global.mapsFcs.getInfoboxOffset();
        var infoBoxOptions = {
            pixelOffset: new google.maps.Size(infoboxOffset.xOffset, infoboxOffset.yOffset),
            alignBottom: true,
            closeBoxURL: global.IMAGES_PATH + "/map/map-infobox-close.gif",
            boxClass: "fshr-map-infobox"
        };
        var placesCount = places.length;
        var pinIcon = {
            url: global.IMAGES_PATH + "/map/map-pin-default.png",
            size: new google.maps.Size(20, 24),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(0, 24),
            scaledSize: new google.maps.Size(20, 24)
        };
        var pinIconCurrent = {
            url: global.IMAGES_PATH + "/map/map-pin-current.png",
            size: new google.maps.Size(20, 24),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(0, 24),
            scaledSize: new google.maps.Size(20, 24)
        };
        for (var index = 0; index < placesCount; index++) {
            var pinData = places[index];
            var showCurrent = handleCurrentHotel && pinData.current;
            if (typeof pinData != "undefined" && "position" in pinData) {
                var pinId = pinData.id;
                infoBoxOptions["content"] = global.mapsFcs.getInfoBoxContent(pinData);
                var currentInfoBox = new InfoBox(infoBoxOptions);
                currentInfoBox["fshr-marker-id"] = pinId;
                var position = new google.maps.LatLng(pinData.position.lat, pinData.position.lng);
                var marker = new google.maps.Marker({
                    position: position,
                    icon: !showCurrent ? pinIcon : pinIconCurrent,
                    fshrMarkerId: pinId
                });
                bounds.extend(position);
                clustererPositions.push(marker);
                global.commonMaps[mapId].markers = global.commonMaps[mapId].markers || {};
                global.commonMaps[mapId].infoBoxes = global.commonMaps[mapId].infoBoxes || {};
                global.commonMaps[mapId]["markers"][pinId] = marker;
                global.commonMaps[mapId]["infoBoxes"][pinId] = currentInfoBox;
                google.maps.event.addListener(marker, "click", function () {
                    var $map = $(this.getMap().getDiv());
                    var mapId = $map.attr("id");
                    var allInfoBoxes = global.commonMaps[mapId]["infoBoxes"];
                    global.mapsFcs.openInfoBox(allInfoBoxes[this.fshrMarkerId], this, map, allInfoBoxes);
                });
                google.maps.event.addListener(currentInfoBox, "domready", function () {
                    $(".fshr-map-infobox .js-tooltip").each(global.initializeQtip);
                    $(".fshr-map-infobox .js-gtm-eventClick").on("click", window.handleGtmEventClick);
                    $(".fshr-map-infobox .js-gtm-productClick").on("click", window.handleGtmProductClick);
                });

                if (showCurrent) {
                    var currentMarker = marker;
                    var currentMarkerInfoBox = currentInfoBox;
                    $map.addClass("js-showCurrent");
                }
            }
        }

        if (clustererPositions.length) {
            var mapClustererOptions = {
                gridSize: 50,
                maxZoom: 9,
                styles: [{
                    url: global.IMAGES_PATH + "map-cluster01.svg",
                    width: 34,
                    height: 34,
                    textColor: '#fff',
                    textSize: 14
                }, {
                    url: global.IMAGES_PATH + "map-cluster02.svg",
                    width: 39,
                    height: 39,
                    textColor: '#fff',
                    textSize: 14
                }, {
                    url: global.IMAGES_PATH + "map-cluster03.svg",
                    width: 45,
                    height: 45,
                    textColor: '#fff',
                    textSize: 14
                }, {
                    url: global.IMAGES_PATH + "map-cluster04.svg",
                    width: 53,
                    height: 53,
                    textColor: '#fff',
                    textSize: 14
                }]
            };
            global.commonMaps[mapId].mapClusters = new MarkerClusterer(map, clustererPositions, mapClustererOptions);
        }

        if (handleCurrentHotel && currentMarker) {
            //var idleEvent = google.maps.event.addListener(map, "idle", function () {
                map.setCenter(currentMarker.position);
                global.mapsFcs.openInfoBox(currentMarkerInfoBox, currentMarker, map);
                map.setZoom(11);
                //google.maps.event.removeListener(idleEvent);
                google.maps.event.trigger(map, "resize");
            //});
        } else if (fitBounds) {
            map.fitBounds(bounds);
        }
        return bounds;
    },
    showHotelsOnMapLEAFLET: function (map, places, fitBounds, handleCurrentHotel) {
        var $map = $(map.getContainer());
        var mapId = $map.attr("id");
        var global = globalWrapper.fshr;
        global.commonMaps = global.commonMaps || {};
        if (typeof fitBounds === "undefined") {
            fitBounds = false;
        }

        var boundary = [];
        for(var i in places){
            boundary.push([places[i].position.lat, places[i].position.lng]);
        }

        var bounds = L.latLngBounds(boundary);

        var clustererPositions = [];
        var infoboxOffset = globalWrapper.fshr.getInfoboxOffsetLEAFLET();
        /*
        var infoBoxOptions = {
            pixelOffset: new google.maps.Size(infoboxOffset.xOffset, infoboxOffset.yOffset),
            alignBottom: true,
            closeBoxURL: global.IMAGES_PATH + "map-infobox-close.gif",
            boxClass: "fshr-map-infobox"
        };
        */
        var infoBoxOptions = {
            offset: [infoboxOffset.xOffset, infoboxOffset.yOffset],
            className: "fshr-map-infobox",
            closeOnClick: false
        };

        var placesCount = places.length;
        var clusterMarkers = L.markerClusterGroup({
            showCoverageOnHover: false,
            zoomToBoundsOnClick: false
        });
        for (var index = 0; index < placesCount; index++) {
            var pinData = places[index];
            var showCurrent = handleCurrentHotel && pinData.current;
            if (typeof pinData != "undefined" && "position" in pinData) {
                var pinId = pinData.id;
                var currentInfoBox = L.popup(infoBoxOptions);
                currentInfoBox.setContent(global.mapsFcs.getInfoBoxContent(pinData));
                currentInfoBox["fshr-marker-id"] = pinId;
                var position = [pinData.position.lat, pinData.position.lng];
                if("apartment" in pinData && pinData.apartment){
                    var icon = L.Icon.extend({
                        options: {
                            iconUrl: !showCurrent ? global.IMAGES_PATH + "/map/map-pin-apartment.png" : global.IMAGES_PATH + "/map/map-pin-current.png",
                            iconSize: [20, 35]
                        }
                    });
                }else{
                    var icon = L.Icon.extend({
                        options: {
                            iconUrl: !showCurrent ? global.IMAGES_PATH + "/map/map-pin-default.png" : global.IMAGES_PATH + "/map/map-pin-current.png",
                            iconSize: [20, 35]
                        }
                    });
                }

                var marker = L.marker(position, {
                    icon: new icon(),
                    fshrMarkerId: pinId
                });
                bounds.extend(position);
                marker.bindPopup(currentInfoBox).on('popupopen', function (event, popup) {
                    var $popup = $(event.popup.getContent());
                    var $lazyLoad = $popup.find(".js-lazyLoad");
                    if ($lazyLoad.length) {
                        $lazyLoad.each(function () {
                            globalWrapper.fshr.handleLazyLoad($(this));
                        });
                    }
                });
                if("current" in pinData && pinData.current){
                    marker.addTo(map);
                }else{
                    clusterMarkers.addLayer(marker);
                }

                if(global.commonMaps[mapId]){
                    global.commonMaps[mapId].markers = global.commonMaps[mapId].markers || {};
                    global.commonMaps[mapId].infoBoxes = global.commonMaps[mapId].infoBoxes || {};
                    global.commonMaps[mapId]["markers"][pinId] = marker;
                    global.commonMaps[mapId]["infoBoxes"][pinId] = currentInfoBox;
                }

                if (showCurrent) {
                    var currentMarker = marker;
                    var currentMarkerInfoBox = currentInfoBox;
                    $map.addClass("js-showCurrent");
                }
            }
        }


        clusterMarkers.on('clusterclick', function (a) {
            a.layer.zoomToBounds();
        });

        if(global.commonMaps[mapId]){
            global.commonMaps[mapId].mapClusters = clusterMarkers;
        }
        clusterMarkers.addTo(map);


        if (handleCurrentHotel && currentMarker) {
            //var idleEvent = google.maps.event.addListener(map, "idle", function () {
            map.setView(currentMarker.getLatLng(), 13, false);
            global.mapsFcs.openInfoBoxLEAFLET(currentMarkerInfoBox, currentMarker, map);

                //google.maps.event.removeListener(idleEvent);
                //google.maps.event.trigger(map, "resize");
            //});
        } else if (fitBounds) {
            map.fitBounds(bounds);
        }

        setTimeout(function(){
            $map.removeClass("js-mapLoading").removeClass("fshr-mapLoading");
        },2000);

        return bounds;
    },
    setProperOffsetToAllInfoBoxes: function (allInfoBoxes) {
        var global = globalWrapper.fshr;
        for (var markerId in allInfoBoxes) {
            if (allInfoBoxes.hasOwnProperty(markerId)) {
                var infoBox = allInfoBoxes[markerId];
                var infoboxOffset = global.mapsFcs.getInfoboxOffset();
                infoBox.setOptions({
                    pixelOffset: new google.maps.Size(infoboxOffset.xOffset, infoboxOffset.yOffset)
                });
            }
        }
    },
    setProperOffsetToAllInfoBoxesLEAFLET: function (allInfoBoxes) {
        var global = globalWrapper.fshr;
        for (var markerId in allInfoBoxes) {
            if (allInfoBoxes.hasOwnProperty(markerId)) {
                var infoBox = allInfoBoxes[markerId];
                //var infoboxOffset = global.mapsFcs.getInfoboxOffset();
                infoBox.update();
            }
        }
    }
};

globalWrapper.fshr.cookie = {
    set: function (name, value, daysToExpire) {
        var expires = "";
        if (daysToExpire) {
            var expireDate = new Date();
            expireDate.setTime(expireDate.getTime() + (daysToExpire*24*60*60*1000));
            expires = "; expires="+expireDate.toGMTString();
        }
        document.cookie = name+"="+value+expires+"; path=/";
    },
    get: function (name) {
        var value = "; " + decodeURIComponent(document.cookie);
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) {
            return parts.pop().split(";").shift();
        };
},
    remove: function (name) {
        if (globalWrapper.fshr.cookie.get(name)) {
            globalWrapper.fshr.cookie.set(name, "", -1);
        }
    }
};
globalWrapper.fshr.globalAvailability = {
    set: function (data) {
        data = JSON.stringify(data);
        globalWrapper.fshr.cookie.set("CKFischerOccupancy", data);
    },
    get: function () {
        var data = globalWrapper.fshr.cookie.get("CKFischerOccupancy") || "";
        var parsed = [];
        if (globalWrapper.fshr.isJSON(data)) {
            parsed = JSON.parse(data);
        }

        var params = [];
        var filterKeys = globalWrapper.fshr.filterKeys;
        var childrenFree = false;
        var allChildrenCount = 0;
        $.each(parsed, function (index) {
            var room = this;
            var roomCount = index + 1;
            var adultsCount = 0;
            var childrenCount = 0;
            var childrenAges = [];
            var infantsCount = 0;
            if (room.KidFree) {
                childrenFree = true;
            }
            if (room.adults) {
                params.push((filterKeys.adultsCount + roomCount).toUpperCase() + "=" + room.adults);
            }
            if (room.ages && room.ages.length) {
                 $.each(room.ages, function () {
                     var age = this;
                     if (age > 0) {
                         childrenAges.push(age);
                     } else {
                         infantsCount = infantsCount + 1;
                     }
                 });
            }
            allChildrenCount = allChildrenCount + room.children;
            childrenCount = room.children - infantsCount;
            if (childrenCount) {
                params.push((filterKeys.childrenCount + roomCount).toUpperCase() + "=" + childrenCount);
            }
            if (childrenAges.length) {
                params.push((filterKeys.childrenAge + roomCount).toUpperCase() + "=" + childrenAges.join("|"));
            }
            if (infantsCount) {
                params.push((filterKeys.infantsCount + roomCount).toUpperCase() + "=" + infantsCount);
            }
        });
        if (childrenFree && allChildrenCount) {
            params.push((filterKeys.childrenFree).toUpperCase() + "=" + childrenFree);
        }
        return {
            parsed: parsed,
            urlQuery: params.join("&")
        }
    }
};
globalWrapper.fshr.popup = {
    open: function ($popupWindowWrapper) {
        $("body").addClass("fshr-popupWindow--opened");
        var $popupWindow = $popupWindowWrapper.find(".js-popupWindow");
        $popupWindow.css("margin-top", 0).trigger("popup-beforeopen");
        $popupWindowWrapper.fadeIn({
            duration: 200,
            complete: function () {
                var global = globalWrapper.fshr;
                var $mapElements = $popupWindowWrapper.find(".js-google-map:not(.js-map-loaded)");
                $mapElements.each(function () {
                    var $map = $(this);
                    global.initializeMap($map);
                });
                var $mapBranchElements = $popupWindowWrapper.find(".js-google-map-branches:not(.js-map-loaded)");
                $mapBranchElements.each(function () {
                    var $map = $(this);
                    global.initializeMapBranches($map);
                });

                var $popupWindowContent = $popupWindowWrapper.find(".js-popup-window-content");
                $popupWindowWrapper.find(".js-lazyLoad").trigger("need-to-load");
                setTimeout(function () {
                    $popupWindowContent.css("height", "");
                    $popupWindowContent.attr("data-default-height", parseInt($popupWindowContent.parent().height(), 10));
                });
                $popupWindow.trigger("popup-afteropen");
            }
        });
    },
    scrollable: function ($popupWindow) {
        var outerPadding = 26;
        var bottomPadding = 16;
        var $addContentTo = $popupWindow.find(".js-popupWindow-content");
        var $parent = $addContentTo.parent();
        $parent.css({
            height: ""
        });
        var $overlay = $popupWindow.closest(".fshr-popupWindow-overlay");
        $overlay.removeClass("fshr-popupWindow--scrollable");
        var isTallerThanWindow = $popupWindow.outerHeight() > $(window).outerHeight();
        if (isTallerThanWindow && $parent.length > 0 && $popupWindow.length > 0) {
            $overlay.addClass("fshr-popupWindow--scrollable");
            var contentToHeight = $(window).outerHeight() - ($parent.offset().top - $popupWindow.offset().top) - outerPadding - bottomPadding;
            $parent.height(contentToHeight);
        }
    }
};
globalWrapper.fshr.widths = {
    window: jQuery(window).width(),
    tablet: 900,
    mobile: 600
};

globalWrapper.fshr.getProperSuffix = function (value, suffix) {
    var suffixes = suffix.split(",");
    var returnValue = "";
    if (5 <= value || isNaN(value) || value == 0) {
        returnValue = suffixes[2] || suffixes[0];
    } else if (1 < value && value < 5) {
        returnValue = suffixes[1] || suffixes[0];
    } else {
        returnValue = suffixes[0];
    }

    return returnValue;
};

globalWrapper.fshr.handleNameAndValue = function (name, value, data) {
    if (/\[\]$/.test(name)) {
        name = name.replace("[]", "");
        if (name in data) {
            if (Array.isArray(value)) { // multiselect vrací pole
                $.each(value, function (index, val) {
                    if (data[name].indexOf(val) == -1) {
                        data[name].push(val);
                    }
                });
            } else {
                if (data[name].indexOf(value) == -1) {
                    data[name].push(value);
                }
            }
        } else {
            if (Array.isArray(value)) {
                data[name] = value;
            } else {
                data[name] = [value];
            }
        }
    } else {
        data[name] = value;
    }
    return data;
};

globalWrapper.fshr.getFormsData = function ($forms) {
    var data = {};
    $forms.each(function () {
        var $form = $(this);
        var $inputs = $form.find("input[name]:not(.js-form-dontInclude), select[name]:not(.js-form-dontInclude), textarea[name]:not(.js-form-dontInclude), button[name].js-form-include");
        $inputs.each(function () {
            var $input = $(this);
            var name = $input.attr("name");
            if (name) {
                var handleData = true;
                if ($input.is("input[type='checkbox'],input[type='radio']")) {
                    if (!$input.is(":checked") && !$input.hasClass("js-sendNonChecked")) {
                        handleData = false;
                    }
                }
                if ($input.is("input[type='checkbox'][data-parentcheckbox-id]")) {
                    var parentCheckboxId = $input.attr("data-parentcheckbox-id");
                    var $wrapper = $input.closest(".js-cascadeCheckboxes");
                    var $parentCheckbox = $wrapper.find("input[type='checkbox'][data-checkbox-id='" + parentCheckboxId + "']").first();
                    if ($parentCheckbox.is(":checked")) {
                        handleData = false;
                    }
                }

                if (handleData) {
                    if($input.hasClass("js-sendNonChecked") && !$input.is(":checked")){
                        var value = $input.attr("data-nonchecked-value");
                    }else {
                        var value = $input.val();
                    }
                    data = globalWrapper.fshr.handleNameAndValue(name, value, data);
                }
            }
        });
    });
    return data;
};

/**
 * google map for branches
 * */
(function ($, global) {
    var MAP_BRANCHES_ALL = 1;
    var MAP_BRANCHES_FISCHER = 2;
    var MAP_BRANCHES_COMMISSION = 3;

    var mapClustererOptions = {
        gridSize: 40,
        maxZoom: 9,
        styles: [{
            url: global.IMAGES_PATH + "map-cluster02.svg", // fischer
            width: 39,
            height: 39,
            textColor: '#fff',
            textSize: 14
        }, {
            url: global.IMAGES_PATH + "map-cluster02.svg", // provizák
            width: 39,
            height: 39,
            textColor: '#fff',
            textSize: 14
        }, {
            url: global.IMAGES_PATH + "map-cluster02.svg", // fischer i provizák
            width: 39,
            height: 39,
            textColor: '#fff',
            textSize: 14
        }]
    };

    var clusterer = {};

    function updateLocationInput ($input, address) {
        $input.val(address);
    }
    function setAddressFromLocation (location, map) {
        var address = "";
        var geocoder = new google.maps.Geocoder;
        geocoder.geocode({location: location}, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                var result = results[1];
                if (result) {
                    address = result.formatted_address;
                    var $map = $(map.getDiv());
                    var inputSelector = $map.attr("data-map-search-selector") || "closest(.js-parent)->find(.js-map-search)";
                    var $input = global.getElementsBySelector(inputSelector, $map);
                    if ($input) {
                        updateLocationInput($input, address);
                    }
                }
            }
        });
    }
    function setAddressFromLocationLEAFLET (location, map) {
        /*
        var address = "";
        var geocoder = new google.maps.Geocoder;
        geocoder.geocode({location: location}, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                var result = results[1];
                if (result) {
                    address = result.formatted_address;
                    var $map = $(map.getDiv());
                    var inputSelector = $map.attr("data-map-search-selector") || "closest(.js-parent)->find(.js-map-search)";
                    var $input = global.getElementsBySelector(inputSelector, $map);
                    if ($input) {
                        updateLocationInput($input, address);
                    }
                }
            }
        });

         */
    }

    function getClosestMarker (location, markers) {
        var distance = Infinity;
        var closestMarker = {};
        for (var index in markers) {
            if (markers.hasOwnProperty(index)) {
                var branchInfo = markers[index];
                var marker = branchInfo.marker;
                var infoBox = branchInfo.infoBox;
                if (!branchInfo.exclude) {
                    // distance is in meters
                    var newDistance = google.maps.geometry.spherical.computeDistanceBetween(marker.getPosition(), location);
                    if (newDistance < distance) {
                        distance = newDistance;
                        closestMarker = {
                            marker: marker,
                            distance: distance,
                            infoBox: infoBox
                        };
                    }
                }
            }
        }
        return closestMarker;
    }
    function getClosestMarkerLEAFLET (map, location, markers) {
        var distance = Infinity;
        var closestMarker = {};
        for (var index in markers) {
            if (markers.hasOwnProperty(index)) {
                var branchInfo = markers[index];
                var marker = branchInfo.marker;
                var infoBox = branchInfo.infoBox;
                if (!branchInfo.exclude) {
                    // distance is in meters
                    //var newDistance = google.maps.geometry.spherical.computeDistanceBetween(marker.getPosition(), location);
                    var newDistance = map.distance(marker.getLatLng(), location);
                    if (newDistance < distance) {
                        distance = newDistance;
                        closestMarker = {
                            marker: marker,
                            distance: distance,
                            infoBox: infoBox
                        };
                    }
                }
            }
        }
        return closestMarker;
    }
    function handleClosestMarker (location, markers, map) {
        var closestMarker = getClosestMarker(location, markers);
        var bounds = new google.maps.LatLngBounds();
        bounds.extend(location);
        bounds.extend(closestMarker.marker.getPosition());

        map.fitBounds(bounds);
        var modifiedMapZoom = map.getZoom() - 1;
        var maximumZoom = 15;
        if (modifiedMapZoom > maximumZoom) {
            map.setZoom(maximumZoom);
        } else {
            map.setZoom(modifiedMapZoom);
        }
        map.setCenter(location);

        openInfoBox(closestMarker.infoBox, closestMarker.marker, map);
    }
    function handleClosestMarkerLEAFLET (location, markers, map) {
        var closestMarker = getClosestMarkerLEAFLET(map, location, markers);
        var bounds = L.latLngBounds(location, closestMarker.marker.getLatLng());

        map.fitBounds(bounds);
        var modifiedMapZoom = map.getZoom() - 1;
        var newZoom = modifiedMapZoom;
        var maximumZoom = 15;
        if (modifiedMapZoom > maximumZoom) {
            newZoom = maximumZoom;
        }
        map.setView(location, newZoom);

        globalWrapper.fshr.mapsFcs.openInfoBoxLEAFLET(closestMarker.infoBox, closestMarker.marker, map);
    }

    function setCurrentLocationInMap (map, userMarker) {
        var location = {};
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var coords = position.coords;
                location = {
                    lat: coords.latitude,
                    lng: coords.longitude
                };
                map.setCenter(location);
                setAddressFromLocation(location, map);
                userMarker.setPosition(location);
                var mapId = $(map.getDiv()).attr("id");
                handleClosestMarker(new google.maps.LatLng(location.lat, location.lng), getGlobalBranchesLocations(mapId), map);
            }, function (error) {
                //openDefaultMarker(map);
            });
        } else {
            //openDefaultMarker(map);
        }
    }
    function setCurrentLocationInMapLEAFLET (map, userIcon) {
        var location = {};
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var coords = position.coords;
                location = [coords.latitude, coords.longitude];
                map.setView(location);
                setAddressFromLocationLEAFLET(location, map);
                if (userIcon) {
                    var userMarker = L.marker(location, {
                        icon: new userIcon()
                    });
                    userMarker.addTo(map);
                }
                var mapId = $(map.getContainer()).attr("id");

                handleClosestMarkerLEAFLET(location, getGlobalBranchesLocations(mapId), map);
            }, function (error) {
                console.log("error", error);
                //openDefaultMarker(map);
            });
        } else {
            //openDefaultMarker(map);
        }
    }
    function setMarkerFromAddress (location, map) {
        var geocoder = new google.maps.Geocoder;
        geocoder.geocode({'address': location.address}, function(results, status) {
            var geocodeStatuses = google.maps.GeocoderStatus;
            switch (status) {
                case geocodeStatuses.OK:
                    setMarker(results[0].geometry.location, location, map);
                break;
                case geocodeStatuses.ZERO_RESULTS:
                    console.error("ZERO_RESULTS");
                break;
                case geocodeStatuses.OVER_QUERY_LIMIT:
                    console.error("OVER_QUERY_LIMIT");
                break;
                case geocodeStatuses.REQUEST_DENIED:
                    console.error("REQUEST_DENIED");
                break;
                case geocodeStatuses.INVALID_REQUEST:
                    console.error("INVALID_REQUEST");
                break;
                case geocodeStatuses.UNKNOWN_ERROR:
                    console.error("UNKNOWN_ERROR");
                break;
            }
        });
    }
    function getInfoBoxContent (location) {
        var title = location.name;
        var address = location.address;
        var url = location.url;
        var imageSrc = (("info" in location) && ("images" in location.info) && location.info.images.length) ? location.info.images[0] : "";

        var $html = $(url ? "<a href='" + url + "' class='fshr-mapItemTooltip" + ( !imageSrc ? " fshr-mapItemTooltip--noImage" : "") + "'></a>" : "<div class='fshr-mapItemTooltip" + ( !imageSrc ? " fshr-mapItemTooltip--noImage" : "") + "'></div>");
        var image = imageSrc ? "<div class='fshr-mapItemTooltip-image js-lazyLoad' data-lazy-style='background-image: url(" + imageSrc + ");'></div>" : "";
        var $content = $("" +
            "<div class='fshr-mapItemTooltip-content'>" +
                image +
            "   <p class='fshr-mapItemTooltip-title'>" + title + "</p>" +
            "   <p class='fshr-paragraph'>" + address + "</p>" +
            "</div>");
        $html.append($content);

        return $html[0];
    }
    function setMarker (position, location, map) {
        var pinUrl = global.IMAGES_PATH + "map-pin-default.png";
        if (location.commission) {
            pinUrl = global.IMAGES_PATH + "map-pin-dealer.png";
        }

        if (location.current) {
            pinUrl = global.IMAGES_PATH + "map-pin-current.png";
        }

        var pinIcon = {
            url: pinUrl,
            size: new google.maps.Size(20, 24),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(0, 24),
            scaledSize: new google.maps.Size(20, 24)
        };
        var marker = new google.maps.Marker({
            map: map,
            position: position,
            title: location.name,
            icon: pinIcon
        });
        marker["fshr-marker-id"] = location.id;
        marker["fshr-commission"] = location.commission || false;
        var branchImages = "info" in location && "images" in location.info ? location.info.images : [];
        var branchImagesCount = (branchImages && branchImages.length) ? branchImages.length : 0;
        var infoboxOffset = global.getInfoboxOffset(branchImagesCount);
        var infoBoxOptions = {
            alignBottom: true,
            pixelOffset: new google.maps.Size(infoboxOffset.xOffset, infoboxOffset.yOffset),
            closeBoxURL: global.IMAGES_PATH + "/map/map-infobox-close.gif",
            boxClass: "fshr-map-infobox fshr-map-infobox-branch" + (!location.commission ? " fshr-map-infobox-branch-fischer" : "") + (!branchImagesCount ? " fshr-map-infobox-noImage" : "")
        };
        var $map = $(map.getDiv());
        var mapId = $map.attr("id");
        var markerIndex = getGlobalBranchesLocations(mapId).length;
        infoBoxOptions["content"] = getInfoBoxContent(location, markerIndex, map);
        var currentInfoBox = new InfoBox(infoBoxOptions);
        currentInfoBox["fshr-marker-id"] = location.id;
        var markerInfo = {
            marker: marker,
            infoBox: currentInfoBox,
            map: map,
            isCommission: (typeof location.commission !== "undefined") ? location.commission : false
        };
        google.maps.event.addListener(marker, "click", function () {
            openInfoBox(currentInfoBox, this, map);
        });
        var eventData = {
            map: map,
            infoBox: currentInfoBox,
            marker: marker
        };

        google.maps.event.addListener(currentInfoBox, "domready", function () {
            $map.trigger("open-infobox", eventData);
        });
        google.maps.event.addListener(currentInfoBox, "closeclick", function () {
            $map.trigger("close-infobox", eventData);
        });
        setGlobalBranchesLocation(map, location.id, markerInfo);
    }
    function setBranchEventZoomLEAFLET () {
        var map = this;
        global.setMapZoom(map);
        var $popupWindow = $("#popup-branch");
        var branchId = $popupWindow.find(".js-google-map-branches").attr("data-map-branchid");
        if ($popupWindow.length && branchId) {
            $popupWindow.find("select.js-map-select").trigger("select-change");
        }
        map.off("zoomend moveend", setBranchEventZoomLEAFLET);
    }
    function setMarkerLEAFLET (position, location, map, clusterMarkers) {
        var pinUrl = global.IMAGES_PATH + "map-pin-default.png";
        if (location.commission) {
            pinUrl = global.IMAGES_PATH + "map-pin-dealer.png";
        }

        if (location.current) {
            pinUrl = global.IMAGES_PATH + "map-pin-current.png";
        }

        var icon = L.Icon.extend({
            options: {
                iconUrl: pinUrl,
                iconSize: [20, 24]
            }
        });
        var marker = L.marker(position, {
            icon: new icon()
        });

        marker["fshr-marker-id"] = location.id;
        marker["fshr-commission"] = location.commission || false;
        var branchImages = "info" in location && "images" in location.info ? location.info.images : [];
        var branchImagesCount = (branchImages && branchImages.length) ? branchImages.length : 0;


        var infoboxOffset = global.getInfoboxOffsetLEAFLET(branchImagesCount);
        var infoBoxOptions = {
            offset: [infoboxOffset.xOffset, infoboxOffset.yOffset],
            className: "fshr-map-infobox fshr-map-infobox-branch" + (!location.commission ? " fshr-map-infobox-branch-fischer" : "") + (!branchImagesCount ? " fshr-map-infobox-noImage" : ""),
            closeOnClick: false
        };
        var $map = $(map.getContainer());
        var mapId = $map.attr("id");
        var markerIndex = getGlobalBranchesLocations(mapId).length;
        var infoBoxOptionsContent = getInfoBoxContent(location, markerIndex, map);

        var currentInfoBox = L.popup(infoBoxOptions);
        currentInfoBox.setContent(infoBoxOptionsContent);
        currentInfoBox["fshr-marker-id"] = location.id;

        var markerInfo = {
            marker: marker,
            infoBox: currentInfoBox,
            map: map,
            isCommission: (typeof location.commission !== "undefined") ? location.commission : false
        };

        var eventData = {
            map: map,
            infoBox: currentInfoBox,
            marker: marker
        };

        marker.on("popupopen", function () {
            $map.trigger("open-infobox-leaflet", eventData);
        });
        marker.on("popupclose", function () {
            $map.trigger("close-infobox-leaflet", eventData);
        });

        marker.bindPopup(currentInfoBox).on('popupopen', function (event, popup) {
            var $popup = $(event.popup.getContent());
            var $lazyLoad = $popup.find(".js-lazyLoad");
            if ($lazyLoad.length) {
                $lazyLoad.each(function () {
                    globalWrapper.fshr.handleLazyLoad($(this));
                });
            }
        });

        clusterMarkers.addLayer(marker);

        setGlobalBranchesLocationLEAFLET(map, location.id, markerInfo);
    }
    function closeAllInfoBoxes (map) {
        var mapId = $(map.getDiv()).attr("id");
        var branchesLocations = getGlobalBranchesLocations(mapId);
        for (var index in branchesLocations) {
            if (branchesLocations.hasOwnProperty(index)) {
                var infoBox = branchesLocations[index].infoBox;
                infoBox.close();
            }
        }
    }
    function closeAllInfoBoxesLEAFLET (map) {
        var mapId = $(map._content).attr("id");
        var branchesLocations = getGlobalBranchesLocations(mapId);
        for (var index in branchesLocations) {
            if (branchesLocations.hasOwnProperty(index)) {
                var infoBox = branchesLocations[index].infoBox;
                infoBox.closePopup();
            }
        }
    }
    global.closeAllInfoBoxes = closeAllInfoBoxes;
    global.closeAllInfoBoxesLEAFLET = closeAllInfoBoxesLEAFLET;
    function openInfoBox (currentInfoBox, marker, map) {
        closeAllInfoBoxes(map);
        var $infoBox = $(currentInfoBox.getContent());
        var $lazyLoad = $infoBox.find(".js-lazyLoad");
        if ($lazyLoad.length) {
            $lazyLoad.each(function () {
                globalWrapper.fshr.handleLazyLoad($(this));
            });
        }
        currentInfoBox.open(map, marker);
    }
    global.openInfoBox = openInfoBox;
    //global.openInfoBoxLEAFLET = globalWrapper.fshr.mapsFcs.openInfoBoxLEAFLET;
    function addLocationsToMap (locations, map) {
        var markersCount = locations.length;
        var $map = $(map.getDiv());
        $map.attr("data-markers-count", markersCount);
        for (var index = 0; index < markersCount; index++) {
            var location = locations[index];
            if (location.lat && location.lng) {
                var position = {
                    lat: location.lat,
                    lng: location.lng
                };
                setMarker(position, location, map);
            } else {
                setMarkerFromAddress(location, map);
            }
        }
    }
    function addLocationsToMapLEAFLET (locations, map) {
        var markersCount = locations.length;
        var $map = $(map.getContainer());
        $map.attr("data-markers-count", markersCount);
        var clusterMarkers = L.markerClusterGroup({
            showCoverageOnHover: false
        });

        for (var index = 0; index < markersCount; index++) {
            var location = locations[index];
            if (location.lat && location.lng) {
                var position = [location.lat, location.lng];
                setMarkerLEAFLET(position, location, map, clusterMarkers);
            } else {
                setMarkerFromAddress(location, map);
            }
        }
        clusterMarkers.addTo(map);
    }

    function getGlobalBranchesLocations (mapId, filter) {
        var globalMarkers = global.googleBranchesGlobalMarkers[mapId];

        if (typeof filter !== "undefined") {
            var markersCount = globalMarkers.length;
            var index = 0;
            switch (parseInt(filter, 10)) {
                case MAP_BRANCHES_COMMISSION:
                    for (index in globalMarkers) {
                        if (globalMarkers.hasOwnProperty(index)) {
                            globalMarkers[index].exclude = !globalMarkers[index].isCommission;
                        }
                    }
                break;
                case MAP_BRANCHES_FISCHER:
                    for (index  in globalMarkers) {
                        if (globalMarkers.hasOwnProperty(index)) {
                            globalMarkers[index].exclude = globalMarkers[index].isCommission;
                        }
                    }
                break;
                default:
                    for (index  in globalMarkers) {
                        if (globalMarkers.hasOwnProperty(index)) {
                            globalMarkers[index].exclude = false;
                        }
                    }
                break;
            }
        }
        return globalMarkers;

    }
    function setGlobalBranchesLocation (map, locationIndex, locationData) {
        var $map = $(map.getDiv());
        var mapId = $map.attr("id");
        global.googleBranchesGlobalMarkers[mapId][locationIndex] = locationData;
    }
    function setGlobalBranchesLocationLEAFLET (map, locationIndex, locationData) {
        var $map = $(map.getContainer());
        var mapId = $map.attr("id");
        global.googleBranchesGlobalMarkers[mapId][locationIndex] = locationData;
    }

    function getFilterValueElement ($map) {
        var $mapWrapper = $map.closest(".js-map-wrapper");
        var $typeFilter = $mapWrapper.find(".js-branchType");
        var showBranchesType = MAP_BRANCHES_ALL;
        if ($typeFilter.length) {
            var $filterCheckedOption = $typeFilter.find("input:checked");
            showBranchesType = $filterCheckedOption.val();
        }
        return {
            element: $typeFilter,
            branchesType: showBranchesType
        };
    }
    function calcGroupPin (markers, numStyles) {
        var commission = false;
        var fischer = false;
        var index = 2;
        var markersLength = markers.length;
        for (var i = 0; i < markersLength; i++) {
            var marker = markers[i];
            if (marker["fshr-commission"]) {
                commission = true;
            } else {
                fischer = true;
            }
        }
        if (fischer) {
            index = 1;
        }
        if (commission) {
            index = 2;
        }
        if (commission && fischer) {
            index = 3;
        }
        return {text: markersLength, index: index};
    }
    function initBranchesMap ($map) {
        var mapId = $map.attr("id");

        if (!mapId) {
            mapId = "branchesMap" + $map.index() + (new Date().getTime());
            $map.attr("id", mapId);
        }
        global.googleBranchesGlobalMarkers = global.googleBranchesGlobalMarkers || {};
        global.googleBranchesGlobalMarkers[mapId] = [];

        var map = new google.maps.Map($map[0], {
            zoom: 6,
            center: {lat: 49.7437500, lng: 15.3386300},
            mapTypeControl: false,
            streetViewControl: true
        });
        var userMarker = new google.maps.Marker({
            map: map,
            icon: global.IMAGES_PATH + "map-pin-current-location.png"
        });

        // TODO: pin branch here
        var locationsVariableName = $map.attr("data-map-location-variable-name") || "googleMapBranchesLocations";
        var branchesLocations = window[locationsVariableName];
        addLocationsToMap(branchesLocations, map);

        var $mapWrapper = $map.closest(".js-map-wrapper");
        var $input = $mapWrapper.find(".js-map-search");
        var $legend = $mapWrapper.find(".js-map-legend");
        var input = $input[0];
        var legend = $legend[0];
        var autocomplete = false;
        var autocompleteOptions = {
            componentRestrictions: {country: 'cz'}
        };
        if ($input.length) {
            var inputPosition = $input.attr("data-map-position") || "TOP_LEFT";
            map.controls[google.maps.ControlPosition[inputPosition]].push(input);
            autocomplete = new google.maps.places.Autocomplete(input, autocompleteOptions);
        }
        var filter = getFilterValueElement($map);
        if (filter.element.length) {
            map.controls[google.maps.ControlPosition.TOP_CENTER].push(filter.element[0]);
        }
        if ($legend.length) {
            map.controls[google.maps.ControlPosition.LEFT_CENTER].push(legend);
        }

        var autocompleteSelector = $map.attr("data-map-autocomplete-selector");
        var $autocompleteInput = global.getElementsBySelector(autocompleteSelector, $map);
        if ($autocompleteInput.length) {
            autocomplete = new google.maps.places.Autocomplete($autocompleteInput[0], autocompleteOptions);
        }

        if (typeof autocomplete !== "undefined" && autocomplete) {
            autocomplete.bindTo('bounds', map);
            autocomplete.addListener('place_changed', function () {
                var place = autocomplete.getPlace();
                if (place && "geometry" in place && "location" in place.geometry) {
                    var filter = getFilterValueElement($(map.getDiv()));
                    var placeLocation = place.geometry.location;
                    map.setCenter(placeLocation);
                    userMarker.setPosition(placeLocation);
                    var mapId = $(map.getDiv()).attr("id");
                    var markers = getGlobalBranchesLocations(mapId, filter.branchesType);
                    handleClosestMarker(placeLocation, markers, map);
                }
            });
        }

        google.maps.event.addListener(map, 'idle', function() {
            var $actualMap = $(map.getDiv());
            var mapId = $actualMap.attr("id");
            if (!$actualMap.hasClass("js-map-loaded")) {
                google.maps.event.trigger(map, 'resize');
                var mapBounds = new google.maps.LatLngBounds();
                var clusterMarkers = [];

                var branchesType = getFilterValueElement($actualMap).branchesType;
                var globalBranches = getGlobalBranchesLocations(mapId, branchesType);

                for (var index in globalBranches) {
                    if (globalBranches.hasOwnProperty(index)) {
                        var branch = globalBranches[index];
                        var marker = branch.marker;
                        var isExcluded = branch.exclude;
                        if (isExcluded) {
                            marker.setMap(null);
                        } else {
                            marker.setMap(branch.map);
                            clusterMarkers.push(marker);
                            mapBounds.extend(marker.getPosition());
                        }
                    }
                }

                clusterer[mapId] = new MarkerClusterer(map, clusterMarkers, mapClustererOptions);
                clusterer[mapId].setCalculator(calcGroupPin);
                setCurrentLocationInMap(map, userMarker);
                $actualMap.addClass("js-map-loaded");
                var boundsChangeEvent = google.maps.event.addListener(map, 'bounds_changed', function() {
                    var map = this;
                    global.setMapZoom(map);
                    var $popupWindow = $("#popup-branch");
                    var branchId = $popupWindow.find(".js-google-map-branches").attr("data-map-branchid");
                    if ($popupWindow.length && branchId) {
                        $popupWindow.find("select.js-map-select").trigger("select-change");
                    }
                    google.maps.event.removeListener(boundsChangeEvent);
                });

                map.fitBounds(mapBounds);
                var mapZoom = $actualMap.attr("data-map-zoom");
                if (mapZoom) {
                    map.setZoom(parseInt(mapZoom, 10));
                }
            }
        });
    }

    function initBranchesMapLEAFLET ($map) {
        var mapId = $map.attr("id");

        $map.addClass("fshr-mapLoading");

        if (!mapId) {
            mapId = "branchesMap" + $map.index() + (new Date().getTime());
            $map.attr("id", mapId);
        }
        global.googleBranchesGlobalMarkers = global.googleBranchesGlobalMarkers || {};
        global.googleBranchesGlobalMarkers[mapId] = [];

        var map = L.map($map[0], {
            center: [49.7437500, 15.3386300],
            zoom: 6,
            attributionControl: false,
            maxZoom: 18
        });
        /*
        var userMarker = new google.maps.Marker({
            map: map,
            icon: global.IMAGES_PATH + "map-pin-current-location.png"
        });

         */


        /*
        L.tileLayer(global.mapSourceUrl, {
            maxZoom: 18
        }).addTo(map);
        */
        var gl = L.mapboxGL({
            accessToken: "no-token",
            style: global.mapSourceUrl,
            maxZoom: 18
        }).addTo(map);

        var locationsVariableName = $map.attr("data-map-location-variable-name") || "googleMapBranchesLocations";
        var branchesLocations = window[locationsVariableName];

        addLocationsToMapLEAFLET(branchesLocations, map);

        var $mapWrapper = $map.closest(".js-map-wrapper");
        var $input = $mapWrapper.find(".js-map-search");
        var $legend = $mapWrapper.find(".js-map-legend");
        var legend = $legend[0];
        if ($input.length) {
            $input.remove();
            L.Control.geocoder({
                collapsed: false,
                defaultMarkGeocode: false,
                placeholder: globalWrapper.fshr.localization.search.search + "...",
                errorMessage: globalWrapper.fshr.localization.search.nothingFound
            }).on('markgeocode', function (event) {
                var geocode = event.geocode;
                handleClosestMarkerLEAFLET(geocode.center, getGlobalBranchesLocations(mapId), map);
            }).addTo(map);
            /*
            var inputPosition = "topright";
            var mapInput = L.control({position: 'topright'});
            mapInput.onAdd = function () {
                return input;
            };
            mapInput.addTo(map);
            //autocomplete = new google.maps.places.Autocomplete(input, autocompleteOptions);

             */
        }

        var filter = getFilterValueElement($map);
        if (filter.element.length) {
            var mapFilter = L.control({position: 'bottomright'});
            mapFilter.onAdd = function () {
                return filter.element[0];
            };
            //map.controls[google.maps.ControlPosition.TOP_CENTER].push(filter.element[0]);
            mapFilter.addTo(map);
        }
        if ($legend.length) {
            var mapLegend = L.control({position: 'bottomleft'});
            mapLegend.onAdd = function () {
                return legend;
            };
            mapLegend.addTo(map);
            //map.controls[google.maps.ControlPosition.LEFT_CENTER].push(legend);
        }


        //map.trigger('resize');
        var mapBounds = L.latLngBounds();

        var branchesType = filter.branchesType;
        var globalBranches = getGlobalBranchesLocations(mapId, branchesType);


        for (var index in globalBranches) {
            if (globalBranches.hasOwnProperty(index)) {
                var branch = globalBranches[index];
                var marker = branch.marker;
                var isExcluded = branch.exclude;
                if (isExcluded) {
                    marker.remove();
                } else {
                    mapBounds.extend(marker.getLatLng());
                }
            }
        }

        /*
        clusterer[mapId] = new MarkerClusterer(map, clusterMarkers, mapClustererOptions);
        clusterer[mapId].setCalculator(calcGroupPin);

         */
        var userIcon = L.Icon.extend({
            options: {
                iconUrl: global.IMAGES_PATH + "map-pin-current-location.png",
                size: [16,16]
            }
        });

        setCurrentLocationInMapLEAFLET(map, userIcon);
        $map.addClass("js-map-loaded");
        //map.on('zoomend moveend', setBranchEventZoomLEAFLET);

        if (mapBounds.isValid()) {
            map.fitBounds(mapBounds);
        }
        var mapZoom = $map.attr("data-map-zoom");
        if (mapZoom) {
            map.setZoom(parseInt(mapZoom, 10));
        }
        setTimeout(function () {
            $map.removeClass("fshr-mapLoading");
        }, 2000);


    }
    global.initializeMapBranches = initBranchesMapLEAFLET;

    $(".js-google-map-branches:visible:not(.js-lazyLoad)").each(function () {
        var $this = $(this);
        initBranchesMapLEAFLET ($this);
    });
    // because of autocomplete, ofter hit Enter form was submited
    $(".js-map-wrapper").on("keyup keypress", function (event) {
        var keyCode = event.keyCode;
        if (keyCode === 13) {
            return false;
        }
    });

    $(".js-branchType input").on("change", function () {
        var $input = $(this);
        var $map = $input.closest(".js-google-map-branches");
        var mapId = $map.attr("id");
        clusterer[mapId].setMap(null);
        var branchesType = $input.val();
        var mapBounds = new google.maps.LatLngBounds();
        var clusterMarkers = [];

        var globalBranches = getGlobalBranchesLocations(mapId, branchesType);
        var map = false;

        for (var index = 0, markersCount = globalBranches.length; index < markersCount; index++) {
            var branch = globalBranches[index];
            var marker = branch.marker;
            var infoBox = branch.infoBox;
            var isExcluded = branch.exclude;
            if (!map) {
                map = branch.map;
            }
            if (isExcluded) {
                marker.setMap(null);
                infoBox.setVisible(false);
            } else {
                marker.setMap(branch.map);
                infoBox.setVisible(true);
                clusterMarkers.push(marker);
                mapBounds.extend(marker.getPosition());
            }
        }
        clusterer[mapId] = new MarkerClusterer(map, clusterMarkers, mapClustererOptions);
    });
})(jQuery, globalWrapper.fshr);
